const parseVersion = (version) => {
    const input = String(version ?? "").trim();
    const match = input.match(/^(?<base>\d+(?:\.\d+)*)(?:_(?<suffix>.+))?$/);

    if (!match?.groups) {
        return {
            base: [0],
            suffixRank: 0,
            suffixValue: 0,
            suffixText: input,
        };
    }

    const base = match.groups.base
        .split(".")
        .map(part => Number.parseInt(part, 10) || 0);
    const suffix = match.groups.suffix ?? "";

    if (suffix.length === 0) {
        return { base, suffixRank: 0, suffixValue: 0, suffixText: "" };
    }

    const buildMatch = suffix.match(/^build-(\d+)$/);
    if (buildMatch) {
        return {
            base,
            suffixRank: 2,
            suffixValue: Number.parseInt(buildMatch[1], 10) || 0,
            suffixText: suffix,
        };
    }

    if (/^\d+$/.test(suffix)) {
        return {
            base,
            suffixRank: 1,
            suffixValue: Number.parseInt(suffix, 10) || 0,
            suffixText: suffix,
        };
    }

    return { base, suffixRank: 3, suffixValue: 0, suffixText: suffix };
};

export const comparePluginVersions = (leftVersion, rightVersion) => {
    const left = parseVersion(leftVersion);
    const right = parseVersion(rightVersion);
    const maxLength = Math.max(left.base.length, right.base.length);

    for (let index = 0; index < maxLength; index++) {
        const leftPart = left.base[index] ?? 0;
        const rightPart = right.base[index] ?? 0;

        if (leftPart !== rightPart) {
            return leftPart - rightPart;
        }
    }

    if (left.suffixRank !== right.suffixRank) {
        return left.suffixRank - right.suffixRank;
    }

    if (left.suffixValue !== right.suffixValue) {
        return left.suffixValue - right.suffixValue;
    }

    return left.suffixText.localeCompare(right.suffixText);
};
